const BusinessNameNotice = () => (
  <div className="p-4 rounded-xl bg-[#E8F2F4] border border-[#153e46]/15 text-xs text-[#153e46] leading-relaxed">
    You can upload your business name here. Make sure it matches the registered
    name on your CAC certificate so your business verification can be
    successful.
  </div>
);

export default BusinessNameNotice;
